import { frontendURL } from '../../../helper/URLHelper';
import { ROLES } from 'dashboard/constants/permissions';

const WhatsApp = () => import('./WhatsApp.vue');
const WhatsAppDetail = () => import('./WhatsAppDetail.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/whatsapp'),
      name: 'whatsapp_index',
      meta: { permissions: ROLES },
      component: WhatsApp,
    },
    {
      path: frontendURL('accounts/:accountId/whatsapp/:inboxId'),
      name: 'whatsapp_detail',
      meta: { permissions: ROLES },
      component: WhatsAppDetail,
    },
  ],
};
